export var DialogType;
(function (DialogType) {
    DialogType["SIMPLE"] = "SIMPLE";
    DialogType["SIMPLE_WITH_CHECKBOX"] = "SIMPLE_WITH_CHECKBOX";
    DialogType["UPDATE_USERNAME"] = "UPDATE_USERNAME";
    DialogType["UPDATE_BILLING_INFORMATION"] = "UPDATE_BILLING_INFORMATION";
    DialogType["SHOP_BUY"] = "SHOP_BUY";
    DialogType["BUY_SINGLE_ASSET"] = "BUY_SINGLE_ASSET";
    DialogType["BUY_SINGLE_ASSET_FOR_CRAFT"] = "BUY_SINGLE_ASSET_FOR_CRAFT";
    DialogType["BUY_MULTIPLE_ASSETS"] = "BUY_MULTIPLE_ASSETS";
    DialogType["MAKE_OFFER"] = "MAKE_OFFER";
    DialogType["TRANSFER_ASSET"] = "TRANSFER_ASSET";
    DialogType["SHRED"] = "SHRED";
    DialogType["LIST_FOR_SALE_SINGLE"] = "LIST_FOR_SALE_SINGLE";
    DialogType["LIST_FOR_SALE_MULTIPLE"] = "LIST_FOR_SALE_MULTIPLE";
    DialogType["MINT_MULTIPLE"] = "MINT_MULTIPLE";
    DialogType["ASSET_CARD_HISTORY"] = "ASSET_CARD_HISTORY";
    DialogType["STAKING_RECAP"] = "STAKING_RECAP";
    DialogType["COMPLETION_PROGRESS"] = "COMPLETION_PROGRESS";
    DialogType["BUY_FREE_MINT"] = "BUY_FREE_MINT";
    DialogType["CLAIM_TOKEN"] = "CLAIM_TOKEN";
    DialogType["CUSTOM_NUMBERINGS"] = "CUSTOM_NUMBERINGS";
})(DialogType || (DialogType = {}));
